import React from "react";
import "./FavouriteClients.css";

import Img1 from "../Img/1.webp";
import Img2 from "../Img/2.webp";
import Img3 from "../Img/3.webp";
import Img4 from "../Img/4.webp";

export default function FavouriteClients() {
  return (
    <div className="FavClients-Body">
      <div className="FavClients-Box">
        <p className="FavClients-Text1">|| Favourite Clients</p>
        <p className="FavClients-Text2">Work With Trusted Comapny.</p>

        <div className="FavClients-div">
          <div className="FavClients-div2">
            <FavClientsContent img={Img1} text="Scientistx Tech" />
            <FavClientsContent img={Img2} text="UK HR Cloud" />
          </div>
          <div className="FavClients-div2">
            <FavClientsContent img={Img3} text="Fiverr (Freelance)" />
            <FavClientsContent img={Img4} text="COMPANY" />
          </div>
        </div>
      </div>
    </div>
  );
}

function FavClientsContent({ text, img }) {
  return (
    <div className="FavClientsContent-Body">
      <img src={img} alt="" className="FavClientsContent-Img" />
      <p className="FavClientsContent-Text">{text}</p>
    </div>
  );
}
